export default __webpack_public_path__ + "static/eSEGsTkv-7c1a498a9f4d7ee32ba2fe2467f37a78.svg";